import {
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { CategoryData } from '../model/response/category-data';
import { projectApi } from '../administration/project-api';

export interface ProjectState {
  categories: {
    data: CategoryData[];
    status: 'idle' | 'loading' | 'ready';
  };
}

const initialState: ProjectState = {
  categories: {
    data: [],
    status: 'idle',
  },
};

export const getProjects = createAsyncThunk(
  'project/categories',
  async (arg, { getState }) => {
    const state = getState() as RootState;
    if (state.project.categories.status === 'idle') {
      const res = await projectApi.getProjects({
        keyword: '',
        status: '',
      });
      return res;
    }
  },
);

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      getProjects.fulfilled,
      (state, action: any) => {
        if (action.payload) {
          state.categories = {
            data: action.payload,
            status: 'ready',
          };
        }
      },
    );
  },
});

export const {} = projectSlice.actions;

export const selectProject = (state: RootState) =>
  state.project;

export default projectSlice.reducer;
